import React, { useState, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import QRCode from "qrcode";

export default function Stock({
  index,
  setStock,
  stock,
  errors,
  product,
  brandList,
  categories,
}) {
  const [localError, setLocalError] = useState("");

  const removeItem = () => {
    setStock([...stock.slice(0, index), ...stock.slice(index + 1)]);
  };

  const updateData = (value, key) => {
    let newArr = [...stock];
    newArr[index][key] = value;

    // Validate unique itemCode
    if (
      key === "itemCode" &&
      stock.some((item, i) => item.itemCode === value && i !== index)
    ) {
      setLocalError("Item code must be unique");
      return;
    }

    setLocalError("");

    // ✅ Store ONLY qrData (NO base64)
    if (key === "itemCode" && value.trim() !== "") {
      newArr[index].qrData = {
        itemCode: value,
        serialNumber: newArr[index]?.serialNumber || "",
      };
    }

    // keep qrData in sync when serial number changes
    if (key === "serialNumber" && newArr[index]?.itemCode) {
      newArr[index].qrData = {
        itemCode: newArr[index].itemCode,
        serialNumber: value,
      };
    }

    setStock(newArr);
  };

  // useEffect(() => {
  //   setLocalError(errors?.[index]);
  // }, [errors, index]);

  return (
    <div className="card p-2">
      <div class="form-group">
        <div className="row">
          <div className="col-11">
            {/* <label for="exampleInputName">Item Code</label> */}
            <b>{index + 1} .</b>
            <br />
            <label htmlFor={`itemCode-${index}`}>Item Code </label>

            <input
              type="text"
              className="form-control"
              placeholder="Item Code"
              value={stock[index]["itemCode"]}
              onChange={(e) => updateData(e.target.value, "itemCode")}
            />
            {localError && (
              <p className="error-message" style={{ color: "red" }}>
                {localError}
              </p>
            )}
            {/* QR code */}
            {stock[index].qrCode && !localError && (
              <div className="mt-2">
                <label>QR Code</label>
                <div style={{ padding: "10px" }}>
                  {stock[index].qrData && !localError && (
                    <div className="mt-2">
                      <label>QR Code</label>
                      <div style={{ padding: "10px" }}>
                        <QRCodeSVG
                          value={JSON.stringify(stock[index].qrData)}
                          size={120}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div class="form-group">
        <div className="row">
          <div className="col-11">
            {/* <label for="exampleInputName">Serial Number</label> */}
            <label htmlFor={`serialNumber-${index}`}>
              Serial Number {index + 1}
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Serial Number"
              value={stock[index]["serialNumber"]}
              onChange={(e) => updateData(e.target.value, "serialNumber")}
            />
          </div>
          {index != 0 && (
            <div className="col-1 mt-5">
              <span style={{ color: "red" }} onClick={removeItem}>
                - Remove
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
